export default __webpack_public_path__ + "static/media/waButton.b3e68550.png";